import { Button as Btn } from '@pga/pga-component-library'
import theme from '../../../theme'
import styled from 'styled-components'

const { colors, fonts } = theme

const Button = styled(Btn)`
  max-width: 300px;
  width: 100%;
  padding: 18px;
  font-family: ${fonts.heading};
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  margin-top: 20px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`
Button.displayName = 'Button'

export const LinkAsButton = styled(Btn)`
  ${props => (props.width ? `width: ${props.width}` : `width: 100%`)}
  padding: 15px;
  font-family: ${fonts.heading};
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  margin-top: 20px;

  &:hover {
    text-decoration: none;
    color: ${colors.white};
  }
`

LinkAsButton.displayName = 'LinkAsButton'

export default Button
